<script>
import BaseConfig from './_base-config.vue';
import { mapState } from 'vuex';
import baseplanFreeToPaidReplenishMixin from "@/components/capacity/mx/freetrial-baseplan-replenish";

export default {
  name: 'AudioConferencingAdd2Cart',
  extends: BaseConfig,
  mixins: [baseplanFreeToPaidReplenishMixin],
  created() {
    this.handlePageFristLoad()
  },
  computed: {
    ...mapState({
      refreshCount: state => state.ShoppingCart.refreshCount
    })
  },
  methods: {
    handlePageFristLoad() {
      if (this.refreshCount > 1) return
      if (this.mx_showUnlimited) this.mx_handleUnlimitedShow()
    }
  },
};
</script>
